import { render, staticRenderFns } from "./VIPBadge.vue?vue&type=template&id=2e1d836c&scoped=true&"
import script from "./VIPBadge.vue?vue&type=script&lang=js&"
export * from "./VIPBadge.vue?vue&type=script&lang=js&"
import style0 from "./VIPBadge.vue?vue&type=style&index=0&id=2e1d836c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d836c",
  null
  
)

export default component.exports